"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "resana": {
    "55af61c5": [{
      "hkey": "a69f4bed",
      "slug": "castelminio-san-marco",
      "name": "Castelminio-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "castelminio": [{
      "hkey": "a69f4bed",
      "slug": "castelminio-san-marco",
      "name": "Castelminio-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f33a6130": [{
      "hkey": "a69f4bed",
      "slug": "castelminio-san-marco",
      "name": "Castelminio-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "a69f4bed",
      "slug": "castelminio-san-marco",
      "name": "Castelminio-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "resana"
    }]
  }
};
exports["default"] = _default;